import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "error-wrapper maintenance-bg" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'MaintenanceView',
  setup(__props) {

const MaintenanceSvg = defineAsyncComponent(() => import("@/components/theme/authantication/MaintenanceSvg.vue"))


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(MaintenanceSvg)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "maintenance-heading" }, [
              _createElementVNode("h2", { class: "headline" }, "MAINTENANCE")
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "sub-content" }, [
              _createTextVNode("Our Site is Currently under maintenance We will be back Shortly"),
              _createElementVNode("br"),
              _createTextVNode(" Thank You For Patience")
            ], -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "btn btn-primary",
                to: "/"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("BACK TO HOME PAGE", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})